/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamViewEventResponse
 */
export interface StreamViewEventResponse {
    /**
     * 
     * @type {string}
     * @memberof StreamViewEventResponse
     */
    viewId: string;
    /**
     * 
     * @type {number}
     * @memberof StreamViewEventResponse
     */
    durationSeconds?: number;
}

/**
 * Check if a given object implements the StreamViewEventResponse interface.
 */
export function instanceOfStreamViewEventResponse(value: object): value is StreamViewEventResponse {
    if (!('viewId' in value) || value['viewId'] === undefined) return false;
    return true;
}

export function StreamViewEventResponseFromJSON(json: any): StreamViewEventResponse {
    return StreamViewEventResponseFromJSONTyped(json, false);
}

export function StreamViewEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamViewEventResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'viewId': json['viewId'],
        'durationSeconds': json['durationSeconds'] == null ? undefined : json['durationSeconds'],
    };
}

export function StreamViewEventResponseToJSON(json: any): StreamViewEventResponse {
    return StreamViewEventResponseToJSONTyped(json, false);
}

export function StreamViewEventResponseToJSONTyped(value?: StreamViewEventResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'viewId': value['viewId'],
        'durationSeconds': value['durationSeconds'],
    };
}

